import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { NUDGE_DRIVER, NUDGE_DRIVER_ERROR, NUDGE_DRIVER_SUCCESS } from '../../../actions.js';

function* nudgeDriver({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/bookings/${payload?.id}/nudge-driver`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message || 'Nudge sent to driver');
      yield put({
        type: NUDGE_DRIVER_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Failed to nudge driver');
      yield put({
        type: NUDGE_DRIVER_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: NUDGE_DRIVER_ERROR, payload: error });
  }
}

export function* watchNudgeDriver() {
  yield takeEvery(NUDGE_DRIVER, nudgeDriver);
}

function* nudgeDriverSaga() {
  yield all([fork(watchNudgeDriver)]);
}

export default nudgeDriverSaga;
